import { useLocation, useNavigate } from "react-router-dom";
import { commaDigits, complexDigitToman, convertCurrencyToToman, convertPersian, isEmpty, isEmptyObject, validationMessage } from "../../tools/tools";
import React, { useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import InputMask from "react-input-mask";
import { useAPIDirectCharge, useAPIPublic } from "../../tools/api";
import { getSessionStorage, setSessionStorage, setToken } from "../../tools/services";
import { HandleServicesError } from "../../tools/swalModal";
import { _adr } from "../../address";
import { Helmet } from "react-helmet";

import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";

const PackagePrefactor = () => {
  const mdb = window["mdb"];
  const { queryGateWayByPlanId, redirectEPToIPGBankGateWay, redirectEPToAsanWallet, queryBalance, redirectEPToAccountBalanceGateWay } =
    useAPIDirectCharge();
  const { queryTaxPercent, sendOTPCodeAsync, resendOTPCode, confirmOTPCode } = useAPIPublic();
  const locationState = useLocation();
  const [packages, setPackages] = useState({});
  const [msisdn, setMsisdn] = useState();
  const [tax, setTax] = useState();
  const [calcTax, setCalcTax] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [getwaySelected, setGetwaySelected] = useState(0);
  const [getWay, setGetWay] = useState([]);
  const [randomItems, setRandomItems] = useState([]);
  const [isPayActive, setIsPayActive] = useState(true);
  const [isProcess, setIsProcess] = useState(false);
  const [isProcessOtpCall, setIsProcessOtpCall] = useState(false);
  const [expiretime, setExpiretime] = useState();
  const [sessionid, setSessionid] = useState();
  const [counterDown, setCounterDown] = useState(0);
  const [expireCounterDown, setExpireCounterDown] = useState(false);

  const [remainTime, setRemainTime] = useState(0);
  const [processOtpFire, setProcessOtpFire] = useState(false);
  var xtimer;
  const modalRef = useRef("");
  const inputOtpRefs = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)];
  const [accessWallet, setAccessWallet] = useState(false);

  const [balance, setBalance] = useState(0);
  const bankRef = useRef("");
  const nav = useNavigate();
  useEffect(() => {
    const callAPI = async () => {
      await getTax();
    };
    if (locationState.state?.packages && locationState.state?.msisdn) {
      setPackages(locationState.state?.packages);
      setMsisdn(locationState.state?.msisdn);
    } else if (
      !isEmptyObject(JSON.parse(getSessionStorage("purchasePackages") ? getSessionStorage("purchasePackages") : "{}")) &&
      !isEmpty(getSessionStorage("purchasePackagesMsisdn"))
    ) {
      setPackages(JSON.parse(getSessionStorage("purchasePackages")));
      setMsisdn(getSessionStorage("purchasePackagesMsisdn"));
    } else {
      HandleServicesError();
    }

    callAPI();
  }, []);
  useEffect(() => {
    msisdn && getWayList();
  }, [msisdn]);
  //#region GetWAY
  const getWayList = async () => {
    let req = {
      msisdn: "0999" + msisdn?.replace(/ /g, "")?.replace(/_/g, ""),
      planid: process.env.REACT_APP_EP_PLANID,
    };
    let response = await queryGateWayByPlanId(req);
    if (response) {
      setGetWay(response);
      const selectedItems = await selectRandomObject(response.filter((item) => !item.faBankName.includes("کیف پول")));
      response.map((index, key) => {
        const isChecked = selectedItems.bankId === index.bankId;
        isChecked && setGetwaySelected(index.bankId);
      });
      setRandomItems(selectedItems);
    }
  };

  const selectRandomObject = async (list) => {
    return new Promise((resolve, reject) => {
      try {
        const randomItems = Math.floor(Math.random() * list.length);
        resolve(list[randomItems]);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  };

  const handleCheckedGetway = (bankid) => {
    let isChecked = false;
    if (parseInt(process.env.REACT_APP_EP_BANKID_CREDIT) === getwaySelected && bankid === getwaySelected && balance > 0) {
      isChecked = true;
    } else {
      isChecked = getwaySelected === bankid;
    }
    return isChecked;
  };
  //#endregion Getway

  useEffect(() => {
    calcTotalPrice();
  }, [tax]);
  const getTax = async () => {
    let response = null;
    response = await queryTaxPercent();
    setTax(parseInt(response));
  };
  const calcTotalPrice = () => {
    if (tax && packages?.packagePrice) {
      let _price = (convertCurrencyToToman(packages?.packagePrice) * tax) / 100;
      setCalcTax(_price);
      setTotalPrice(convertCurrencyToToman(packages?.packagePrice) + _price);
    }
  };

  const handleChangeGetway = (e) => {
    if (e.target.value === process.env.REACT_APP_EP_BANKID_CREDIT) {
      setIsPayActive(false);
    } else if (e.target.value === process.env.REACT_APP_EP_BANKID_WALLET) {
      setIsPayActive(false);
    } else {
      setIsPayActive(true);
    }
    setGetwaySelected(parseInt(e.target.value));
  };
  const handlePaymentBank = async (e) => {
    setIsProcess(true);
    setIsPayActive(false);
    e.preventDefault();
    if (parseInt(getwaySelected) === 20066 || parseInt(getwaySelected) === 20104) {
      let req = {
        promotionid: packages?.promotionId,
        msisdn: "0999" + msisdn?.replace(/ /g, "")?.replace(/_/g, ""),
        bankid: getwaySelected,
        planid: process.env.REACT_APP_EP_PLANID,
        packagecode: packages.packageCode,
      };
      let response = await redirectEPToIPGBankGateWay(req);
      if (response) {
        if (response?.includes("html")) {
          bankRef.current.innerHTML = response;
          bankRef.current.querySelector("form")?.submit();
        } else if (response?.includes("form")) {
          bankRef.current.innerHTML = response;
          bankRef.current.querySelector("form")?.removeAttribute("target");
          bankRef.current.querySelector('input[type="submit"]')?.remove();
          bankRef.current.querySelectorAll("input")[1]?.setAttribute("type", "hidden");
          bankRef.current.querySelectorAll("input")[2]?.setAttribute("type", "hidden");
          bankRef.current.querySelector("form")?.submit();
        } else {
          window.location.href = response;
        }
      }
    }
    if (parseInt(getwaySelected) === 20067) {
      let req = {
        bankid: getwaySelected,
        planid: process.env.REACT_APP_EP_PLANID,
        packagecode: packages.packageCode,
      };
      let response = await redirectEPToAccountBalanceGateWay(req);
      if (response) {
        nav(_adr.Root + _adr.Packages + _adr.PackageFactor, {
          replace: true,
          state: {
            amount: response.amount,
            purchasedate: response.purchasedate,
            bankparameterone: response.bankparameterone,
            epmsisdn: response.epmsisdn,
            eppurchasefollowupcode: response.eppurchasefollowupcode,
            packagename: response.packagename,
          },
        });
      }
    }
    setIsProcess(false);
    setIsPayActive(true);
  };
  const handleAccessToWallet = async (values) => {
    setAccessWallet(true);
    let req = {
      walletuser: 9 + values?.msisdn?.replace(/ /g, "")?.replace(/_/g, ""),
      msisdn: "0999" + msisdn?.replace(/ /g, "")?.replace(/_/g, ""),
      bankid: getwaySelected,
      planid: process.env.REACT_APP_EP_PLANID,
      packagecode: packages.packageCode,
    };
    let response = await redirectEPToAsanWallet(req);
    if (response) {
      setSessionStorage("purchasePackages", JSON.stringify(packages));
      setSessionStorage("purchasePackagesMsisdn", msisdn);
      window.location.href = response?.url;
    }
    setAccessWallet(false);
  };

  const handleChange = (index, event) => {
    const input = event.target;
    const value = input.value;

    if (value.length === 1 && index < inputOtpRefs.length - 1) {
      inputOtpRefs[index + 1].current.focus();
    } else if (value.length === 0 && index > 0) {
      inputOtpRefs[index - 1].current.focus();
    }
  };
  useEffect(() => {
    inputOtpRefs[0].current.focus();
  }, []);
  const handleOtpCredit = async () => {
    setIsProcessOtpCall(true);
    let req = {
      checkmsisdnvcertno: false,
      certno: "",
      sessionid: Date.now(),
      msisdn: "999" + msisdn?.replace(/ /g, "")?.replace(/_/g, ""),
      expiretimebyminute: 3,
    };
    let response = await sendOTPCodeAsync(req);
    if (response) {
      setExpiretime(response.expiretime);
      setSessionid(response.sessionid);
      handleOtpTimeDown(response.expiretime);
    }
  };
  const handleOtpTimeDown = (expiretime) => {
    let _timer = expiretime.split(".")[0].split(":")[1];
    var _modal = modalRef.current;
    _modal = new mdb.Modal(_modal, {
      backdrop: "static",
      keyboard: false,
    });
    _modal.show();
    let dt = new Date();
    setCounterDown(dt.setMinutes(dt.getMinutes() + parseInt(_timer) + 1));
  };
  useEffect(() => {
    if (counterDown > 0) {
      xtimer = setInterval(() => {
        var now = new Date().getTime();
        var distance = counterDown - now;
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        setRemainTime(("0" + minutes).slice(-2) + ":" + ("0" + seconds).slice(-2));
        if (distance < 0) {
          clearInterval(xtimer);
          setExpireCounterDown(true);
        }
      }, 1000);
      return () => {
        clearInterval(xtimer);
      };
    }
  }, [counterDown]);

  const handlResendOtp = async (e) => {
    e.preventDefault();
    setProcessOtpFire(true);
    let req = {
      sessionid: sessionid,
      expiretimebyminute: expiretime,
    };
    let response = await resendOTPCode(req);
    if (response) {
      setSessionid(response.sessionid);
      setExpiretime(response.expiretime);
      handleOtpTimeDown(response.expiretime);
    }
    setProcessOtpFire(false);
  };
  const handleConfirmOtp = async (e) => {
    e.preventDefault();
    setProcessOtpFire(true);
    let req = {
      sessionid: sessionid,
      otpvalue: inputOtpRefs
        .map((item) => item.current.value)
        .toString()
        .replace(/,/g, ""),
    };
    let resposne = await confirmOTPCode(req);
    if (resposne) {
      setToken(resposne);
      let _timer = expiretime.split(".")[0].split(":")[1];
      var _modal = modalRef.current;
      _modal = new mdb.Modal.getInstance(_modal);
      _modal.hide();
      let responseBalance = await queryBalance("0999" + msisdn?.replace(/ /g, "")?.replace(/_/g, ""));
      if (responseBalance) {
        setBalance(responseBalance.charginglimitvalue);
        if (responseBalance.charginglimitvalue > packages.packagePrice) {
          setIsPayActive(true);
        }
      }
    }
    setProcessOtpFire(false);
  };

  return (
    <>
      <Helmet>
        <title>بسته‌های اینترنت آپتل - پیش فاکتور</title>
        <meta name="description" content="خرید بسته های مقرون به صرفه" />
        <meta name="keywords" content="خرید بسته آپتل، خرید بسته گردشگری ، خرید بسته ترکی، خرید بسته ارزان، خرید بسته اینترنت" />
      </Helmet>
      <div className="packages pb-4">
        <div className="factor prefactor">
          {/* ----------------------------------------------------------------------------- banner image in page ---------------------------------------------------------- */}
          <figure className="col-12">
            <picture>
              <source media="(min-width:1024px)" srcSet={process.env.REACT_APP_ROOT_PATH_EP + "/directcharge/content/images/packages/banner-pac-md.svg"} />
              <source media="(min-width:320px)" srcSet={process.env.REACT_APP_ROOT_PATH_EP + "/directcharge/content/images/packages/banner-pack-sm.svg"} />
              <img sizes="100%" className="col-12" src={process.env.REACT_APP_ROOT_PATH_EP + "/directcharge/content/images/packages/banner-pac-lg.svg"} alt="" />
            </picture>
            <figcaption style={{ backgroundColor: "#F5F5F5", display: "flex" }} className="d-flex justify-content-center">
              <div className="bread_crumb_wrapper p-2">
                <span className="ml-2">
                  <HomeOutlinedIcon fontSize="medium" />
                </span>
                <span className="ml-2">
                  <ArrowBackIosNewOutlinedIcon fontSize="small" />
                </span>
                <span>انتخاب بسته</span>
                <span className="ml-2 mr-1">
                  <ArrowBackIosNewOutlinedIcon fontSize="small" />
                </span>
                <span>خرید بسته</span>
              </div>
            </figcaption>
          </figure>
          {/* ----------------------------------------------------------------------------- banner image in page ---------------------------------------------------------- */}
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="row justify-content-center">
                  <div className="col-lg-6">
                    <div className="row justify-content-center">
                      <div className="col-lg-10">
                        <div className="hold-package-confrim">
                          <div className="holder-factor">
                            <div className="hold-title">
                              <h3>خرید بسته</h3>
                              <p></p>
                            </div>
                            <div className="holder-factor-item">
                              <ul className="list-unstyled">
                                <li>
                                  <div className="label">شماره:</div>
                                  <div className="value">
                                    <span dir="ltr">0999 {msisdn}</span>
                                  </div>
                                </li>
                                <li>
                                  <div className="label">مبلغ بسته</div>
                                  <div className="value">
                                    <span>{complexDigitToman(packages?.packagePrice)} </span>
                                    تومان
                                  </div>
                                </li>
                                <li>
                                  <div className="label">مالیات بر ارزش افزوده</div>
                                  <div className="value">
                                    <span dir="lrt">
                                      {commaDigits(calcTax)} ({tax ? tax : "0"}
                                      %)
                                    </span>
                                    <span> </span>
                                    تومان
                                  </div>
                                </li>
                                <li>
                                  <div className="label">مبلغ قابل پرداخت</div>
                                  <div className="value">
                                    <span> {commaDigits(totalPrice)} </span>
                                    تومان
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div className="holder-getway">
                              <ul className="list-unstyled">
                                {getWay.map((index, key) => {
                                  const isChecked = handleCheckedGetway(index.bankId);

                                  return (
                                    <React.Fragment key={key}>
                                      <li>
                                        <div className="row-getway">
                                          <div className="form-check">
                                            <input
                                              className="form-check-input"
                                              type="radio"
                                              name="getway"
                                              id={`getway${index.bankId}`}
                                              value={index.bankId}
                                              data-type={index.bankType}
                                              onChange={handleChangeGetway}
                                              checked={isChecked}
                                            />
                                            <label className="form-check-label" htmlFor={`getway${index.bankId}`}>
                                              {index.faBankName}
                                            </label>
                                          </div>

                                          <div className="value">
                                            {parseInt(process.env.REACT_APP_EP_BANKID_CREDIT) === getwaySelected &&
                                              index.bankId === getwaySelected &&
                                              balance > 0 && (
                                                <span className={balance >= packages.packagePrice ? "text-success" : "text-danger"}>
                                                  اعتبار: {complexDigitToman(balance)} تومان
                                                </span>
                                              )}

                                            {parseInt(process.env.REACT_APP_EP_BANKID_CREDIT) === getwaySelected &&
                                              index.bankId === getwaySelected &&
                                              balance === 0 && (
                                                <div className="hold-button">
                                                  <button className={`btn btn-normal ${isProcessOtpCall && "disabled"}`} onClick={handleOtpCredit}>
                                                    {isProcessOtpCall ? <>درحال پردازش</> : <>دریافت کد تایید</>}
                                                  </button>
                                                </div>
                                              )}
                                          </div>
                                        </div>
                                      </li>
                                      {parseInt(process.env.REACT_APP_EP_BANKID_WALLET) === getwaySelected && index.bankId === getwaySelected && (
                                        <Formik
                                          initialValues={{ msisdn: "" }}
                                          validationSchema={yup.object({
                                            msisdn: yup
                                              .string()
                                              .required(validationMessage.required)
                                              .matches("^\\d{9}$", validationMessage.regex)
                                              .transform((value) => {
                                                return value?.replace(/ /g, "");
                                              }),
                                          })}
                                          onSubmit={(values) => {
                                            handleAccessToWallet(values);
                                          }}
                                        >
                                          {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                                            <form onSubmit={handleSubmit} className="mb-3">
                                              <div className="holder-button-input">
                                                <p> لطفا شماره موبایلی با آن اپلیکیشن آپ خود را فعال کرده‌اید وارد کنید.</p>
                                                <div className="row-item">
                                                  <div className="hold-prefix">
                                                    <span className="prefix">09</span>
                                                    <InputMask
                                                      mask="99 99 99 999"
                                                      placeholder="-- -- --"
                                                      value={values.msisdn}
                                                      onChange={(e) => {
                                                        e.target.value = convertPersian(e.target.value);
                                                        handleChange(e);
                                                      }}
                                                      onBlur={handleBlur}
                                                      type="text"
                                                      inputMode="numeric"
                                                      id="msisdn"
                                                      name="msisdn"
                                                      dir="ltr"
                                                      className="form-control"
                                                    />
                                                  </div>
                                                  <div className="hold-button">
                                                    <button type="submit" className={`btn btn-normal ${accessWallet && "disabled"}`}>
                                                      {accessWallet ? <>درحال پردازش</> : <>ادامه</>}
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                              {touched.msisdn && errors.msisdn ? (
                                                <span
                                                  className="error invalid-feedback"
                                                  style={{
                                                    display: "inline",
                                                  }}
                                                >
                                                  {errors.msisdn}
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </form>
                                          )}
                                        </Formik>
                                      )}
                                    </React.Fragment>
                                  );
                                })}
                              </ul>
                            </div>
                            <div className="holder-button mt-3">
                              <div className="row justify-content-right">
                                <div className="col-lg-8">
                                  <button
                                    type="button"
                                    className={`btn ${!isPayActive && "disabled"}`}
                                    disabled={!isPayActive ? true : false}
                                    onClick={handlePaymentBank}
                                  >
                                    {isProcess ? <>درحال پردازش</> : <>پرداخت</>}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row justify-content-center">
                      <div className="col-lg-10">
                        <div className="holder-packages">
                          <div>
                            <div>
                              <div className="item">
                                <div
                                  className="head"
                                  data-type={packages?.packageType === 1 ? "internet" : packages?.packageType === 2 ? "combo" : "roming"}
                                >
                                  <h3>
                                    {packages?.packageType === 1 ? "بسته اینترنت" : packages?.packageType === 2 ? "بسته ترکیبی" : "بسته رومینگ"}
                                  </h3>
                                </div>
                                <div className="body">
                                  <div className="holder-title">
                                    <h3>{packages?.packageName}</h3>
                                    <span>{packages?.packageBillingType === "0" ? <>اعتباری</> : <>دائمی</>}</span>
                                    <br />
                                  </div>
                                  {packages?.voiceCallInDoorDescription !== "0 دقیقه" &&
                                    packages?.voiceCallOutDoorDescription !== "0 دقیقه" &&
                                    packages?.smsDescription !== "0 عدد" && (
                                      <div className="holder-show-option">
                                        {packages?.voiceCallInDoorDescription !== "0 دقیقه" && (
                                          <div className="item">
                                            <span className="label">{packages?.voiceCallInDoorDescription}</span>
                                            <span className="value">
                                              {packages.packageType === 12 ? <>مکالمه با خطوط ترکیه</> : <>مکالمه آپتلی و غیرآپتلی</>}
                                            </span>
                                          </div>
                                        )}
                                        {/* {packages?.voiceCallOutDoorDescription !==
                                          "0 دقیقه" && (
                                          <div className="item">
                                            <span className="label">
                                              {
                                                packages?.voiceCallOutDoorDescription
                                              }
                                            </span>
                                            <span className="value">
                                              مکالمه غیرآپتلی
                                            </span>
                                          </div>
                                        )} */}
                                        {packages?.smsDescription !== "0 عدد" && (
                                          <div className="item">
                                            <span className="label">{packages?.smsDescription}</span>
                                            <span className="value">{packages.packageType === 12 ? <>پیامک به ایران</> : <>پیامک</>}</span>
                                          </div>
                                        )}
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div ref={bankRef}></div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="modalOtp" tabIndex="-1" aria-labelledby="modalOtp" aria-hidden="true" ref={modalRef}>
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="holder-otp">
              <span className="hold-close">
                <i
                  className="icon-close-circle"
                  onClick={() => {
                    setIsProcessOtpCall(false);
                  }}
                  data-dismiss="modal"
                ></i>
              </span>
              <div className="holder-box-flex">
                <div className="box-otp">
                  <h4>کد فعالسازی</h4>
                  <p>
                    لطفا کد فعالسازی ارسال شده به شماره موبایل <span>{"0999" + msisdn?.replace(/ /g, "")?.replace(/_/g, "")} </span>
                    را وارد کنید.
                  </p>
                  <form>
                    <div className="holder-row-input">
                      {inputOtpRefs.map((inputRef, index) => (
                        <input
                          key={index}
                          ref={inputRef}
                          onChange={(event) => {
                            event.target.value = convertPersian(event.target.value);
                            handleChange(index, event);
                          }}
                          inputMode="numeric"
                          maxLength={1}
                        />
                      ))}
                    </div>
                  </form>
                  <div className="holder-ramintime">
                    <span>{!expireCounterDown && remainTime}</span>
                  </div>
                  <div className="holder-button">
                    {!expireCounterDown && (
                      <div
                        className={`btn btn-normal ${processOtpFire && "disabled"}`}
                        onClick={handleConfirmOtp}
                        type="button"
                        disabled={processOtpFire}
                      >
                        {processOtpFire ? <>درحال پردازش</> : <>تایید</>}
                      </div>
                    )}
                    {expireCounterDown && (
                      <div
                        className={`btn btn-normal ${processOtpFire && "disabled"}`}
                        disabled={processOtpFire}
                        onClick={handlResendOtp}
                        type="submit"
                      >
                        {processOtpFire ? <>درحال پردازش</> : <>ارسال مجدد</>}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PackagePrefactor;
